
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "€{{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var valued = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      valued = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      valued = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      valued = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      valued = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, valued);
};

// Page js for fist Step selection.
var $make, $model, $year, $wheel='';
var rightArr = '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 451.846 451.847" style="enable-background:new 0 0 451.846 451.847;" xml:space="preserve"><g><path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744  L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284  c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"/> </g> </svg>';

// Step-1 Make

  // prev button click
  $(document).on('click','.choose_brand .choose_brand_content .choose_brand_step_1.active .btn.mobile-prev', function(e){
    e.preventDefault();
    window.location.href = '/';
  });

  // Choose product
  $(document).on('click','.choose_brand .choose_brand_content .choose_brand_step_1.active ul li', function(e){    
    e.preventDefault();
    var $this = $(this);
    $make = $this.data('make').toUpperCase();  //KTM
    $('.choose_brand_step_2 .heading-main-title').find('.heading.mobile').text($make);
    localStorage.setItem("bikeYearTitle",'');    
    $this.closest('.select-model').removeClass('active');
    $('.choose_brand .choose_brand_content .choose_brand_step_2').addClass('active');
    // $make = $make.toUpperCase(); //KTM
    // console.log('$make',$make);
    // console.log('config_model => ',config_model);
  
    // Brand
    for(var i=0; i < config_model.brand.length; i++){
      console.log('Brand => ',config_model.brand[i].name);    
      // KTM == KTM
      if( config_model.brand[i].name == $make ){      
        console.log('1=>',config_model.brand[i]);
        $('.choose_brand_step_2 .step_2_type').html('');
        var $drawModel='';
        // Make
        for(var j=0; j < config_model.brand[i].make.length; j++){
          console.log('2=>',config_model.brand[i].make[j]);
          $drawModel+='<ul>';
          $drawModel+='<li class="step_2_type_heading"><span class="type_title">'+config_model.brand[i].make[j].name+'</span></li>';
          // Model
          for(var k=0; k < config_model.brand[i].make[j].model.length; k++){
            $drawModel+='<a href="javascript:void(0);"> <li class="choose_brand_details" data-model="'+config_model.brand[i].make[j].model[k].name+'"><span class="brand_type_title"><span class="type_title">'+config_model.brand[i].make[j].model[k].name+'</span><span class="arrow-type"><span class="arrow_icon one">'+rightArr+'</span><span class="arrow_icon two">'+rightArr+'</span></span></span></li> </a>';
          }
          $drawModel+='</ul>';
          $('.choose_brand_step_2 .step_2_type').html($drawModel);
        }// Make
      }
    } // Brand
  });

// Step-2 Model

  // prev button click
  $(document).on('click','.choose_brand .choose_brand_content .choose_brand_step_2.active .btn.mobile-prev', function(e){
    e.preventDefault();  
    var $this2Prev = $(this);
    $this2Prev.closest('.choose_brand_content').find('.choose_brand_step_2').removeClass('active');
    $this2Prev.closest('.choose_brand_content').find('.choose_brand_step_1').addClass('active');
  });

  // Choose Model
  $(document).on('click','.choose_brand .choose_brand_content .choose_brand_step_2.active ul a li', function(e){
    e.preventDefault();
    var $this2 = $(this);
    //$('.choose_brand .choose_brand_content .choose_brand_step_2.active .step_2_type ul a li').removeClass('type_active');
    //$this2.addClass('type_active');
    $model = $this2.data('model').trim();
    $('.choose_brand_step_3 .heading-main-title').find('.heading.mobile').text($model);     //   EXC / EXC-F
    $('.choose_brand_step_3 .heading-main-title').find('.sub-title-mobile').text($make);    //   KTM
    $this2.closest('.select-model').removeClass('active');
    $('.choose_brand .choose_brand_content .choose_brand_step_3').addClass('active');    
    console.log('Step 2 Make => ', $make); console.log('Step 2 Model => ', $model);  
    // Brand
    for(var i=0; i < config_model.brand.length; i++){    
      // console.log('Brand => ',config_model.brand[i].name);    
      // KTM == KTM
      if( config_model.brand[i].name == $make ){
        // console.log('1=>',config_model.brand[i]);
        $('.choose_brand_step_3 .step_3_type').html('');
        var $drawStep3='';
        // Make
        for(var j=0; j < config_model.brand[i].make.length; j++){
          console.log('2=>',config_model.brand[i].make[j].name);
          for(var k=0; k < config_model.brand[i].make[j].model.length; k++){
            if( config_model.brand[i].make[j].model[k].name == $model ){
              console.log('3=>',config_model.brand[i].make[j].model[k].name);            
              if(config_model.brand[i].make[j].model[k].wheels_type != undefined){
                $drawStep3+='<ul>';
                $drawStep3+='<li class="step_3_type_heading"><span class="type_title">Wheels</span></li>';
                for(var y=0; y < config_model.brand[i].make[j].model[k].wheels_type.length; y++){
                  $drawStep3+='<a href="javascript:void(0);"> <li class="choose_brand_details" data-val="'+config_model.brand[i].make[j].model[k].wheels_type[y]+'"><span class="brand_type_title"><span class="type_title">'+config_model.brand[i].make[j].model[k].wheels_type[y]+'</span><span class="arrow-type"><span class="arrow_icon one">'+rightArr+'</span><span class="arrow_icon two">'+rightArr+'</span></span></span></li> </a>';
                }
                $drawStep3+='</ul>';
              }
              else{
                $drawStep3+='<ul>';
                $drawStep3+='<li class="step_3_type_heading"><span class="type_title">'+config_model.brand[i].make[j].model[k].name+'</span></li>';
                for(var y=0; y < config_model.brand[i].make[j].model[k].year_list.length; y++){
                  $drawStep3+='<a href="javascript:void(0);"> <li class="choose_brand_details" data-val="'+config_model.brand[i].make[j].model[k].year_list[y]+'"><span class="brand_type_title"><span class="type_title">'+config_model.brand[i].make[j].model[k].year_list[y]+'</span><span class="arrow-type"><span class="arrow_icon one">'+rightArr+'</span><span class="arrow_icon two">'+rightArr+'</span></span></span></li> </a>';
                }
                $drawStep3+='</ul>';
              }
            }    
          }
          $('.choose_brand_step_3 .step_3_type').html($drawStep3);
        }// Make
      }
    } // Brand
    
  });

// Step-3 Wheels / Year

  // prev button click
  $(document).on('click','.choose_brand .choose_brand_content .choose_brand_step_3.active .btn.mobile-prev', function(e){
    e.preventDefault();  
    var $this2Prev = $(this);
    $this2Prev.closest('.choose_brand_content').find('.choose_brand_step_3').removeClass('active');
    $this2Prev.closest('.choose_brand_content').find('.choose_brand_step_2').addClass('active');
  });

  $(document).on('click','.choose_brand .choose_brand_content .choose_brand_step_3.active ul a li', function(e){
    e.preventDefault();
    var $this3 = $(this);
    $('.choose_brand .choose_brand_content .choose_brand_step_3.active .step_3_type ul a li').removeClass('type_active');
    $this3.addClass('type_active');
    $year = $this3.data('val').trim();
    $('.choose_brand_step_4 .heading-main-title').find('.heading.mobile').text($year);     // 2023
    $('.choose_brand_step_4 .heading-main-title').find('.sub-title-mobile .brand').text($make);    // Make
    $('.choose_brand_step_4 .heading-main-title').find('.sub-title-mobile .model').text($model);    // Model
    var $showStep4 = false;
    //$this3.closest('.select-model').removeClass('active');
    //$('.choose_brand .choose_brand_content .choose_brand_step_4').addClass('active');  
    //console.log('test',$make,$model,$year);
    //console.log('Step 3 Make => ', $make);
    //console.log('Step 3 Model => ', $model);  
    //console.log('Step 3 Year => ', $year);
  
    // Brand
    for(var i=0; i < config_model.brand.length; i++){
      // console.log('Brand => ',config_model.brand[i].name);    
      // KTM == KTM
      if( config_model.brand[i].name == $make ){
        // console.log('1=>',config_model.brand[i]);
        $('.choose_brand_step_4 .step_4_type').html('');
        var $drawStep4='';
        // Make
        for(var j=0; j < config_model.brand[i].make.length; j++){
          // console.log('2=>',config_model.brand[i].make[j].name);
          for(var k=0; k < config_model.brand[i].make[j].model.length; k++){
            if( config_model.brand[i].make[j].model[k].name == $model ){
              // console.log('3=>',config_model.brand[i].make[j].model[k].name);
              if(config_model.brand[i].make[j].model[k].wheels_type != undefined){
                for(var w=0; w < config_model.brand[i].make[j].model[k].wheels.length; w++){
                  if(config_model.brand[i].make[j].model[k].wheels[w].name == $year){
                    $drawStep4+='<ul>';
                    $drawStep4+='<li class="step_4_type_heading"><span class="type_title">'+config_model.brand[i].make[j].model[k].name+'</span></li>';
                    for(var y=0; y < config_model.brand[i].make[j].model[k].wheels[w].year_list.length; y++){
                      var currYr = config_model.brand[i].make[j].model[k].wheels[w].year_list[y];
                      $drawStep4+='<a href="/collections/'+config_model.brand[i].make[j].model[k].wheels[w].year[currYr].handle+'"> <li class="choose_brand_details" data-val="'+config_model.brand[i].make[j].model[k].wheels[w].year_list[y]+'"><span class="brand_type_title"><span class="type_title">'+config_model.brand[i].make[j].model[k].wheels[w].year_list[y]+'</span><span class="arrow-type"><span class="arrow_icon one">'+rightArr+'</span><span class="arrow_icon two">'+rightArr+'</span></span></span></li> </a>';
                    }
                    $drawStep4+='</ul>';
                  }
                }
                $showStep4 = true;
              }
              else{
                for(var y=0; y < config_model.brand[i].make[j].model[k].year_list.length; y++){
                  if( config_model.brand[i].make[j].model[k].year_list[y] == $year ){
                    var selectYear = config_model.brand[i].make[j].model[k].year_list[y];
                    console.log('selectYear =',selectYear);
                    var proHandle = config_model.brand[i].make[j].model[k].year[selectYear].handle;
                    console.log('handle =',config_model.brand[i].make[j].model[k].year[selectYear].handle);
                    // fill title at 3rd step with year
                    localStorage.setItem("bikeYearTitle",$make+' '+$model+' '+$year);
                    location.href='/collections/'+proHandle;
                    return;
                  } //if
                } // for yr_list
                $showStep4 = false;
              }
            }
          } // for model
          
          $('.choose_brand_step_4 .step_4_type').html($drawStep4);
        }// Make
      }
    } // Brand
  
    if($showStep4 == true){
      $this3.closest('.select-model').removeClass('active');
      $('.choose_brand .choose_brand_content .choose_brand_step_4').addClass('active');
    }
  });

// Step-4 Year

  // prev button click
  $(document).on('click','.choose_brand .choose_brand_content .choose_brand_step_4.active .btn.mobile-prev', function(e){
    e.preventDefault();  
    var $this2Prev = $(this);
    $this2Prev.closest('.choose_brand_content').find('.choose_brand_step_4').removeClass('active');
    $this2Prev.closest('.choose_brand_content').find('.choose_brand_step_3').addClass('active');
  });

  // Choose Year
  $(document).on('click','.choose_brand .choose_brand_content .choose_brand_step_4.active ul a li', function(e){
    //e.preventDefault();
    var $this4 = $(this);
    $('.choose_brand .choose_brand_content .choose_brand_step_4.active .step_4_type ul a li').removeClass('type_active');
    $this4.addClass('type_active');
    $year = $this4.data('val').trim();
    // fill title at 4th step with year
    localStorage.setItem("bikeYearTitle",$make+' '+$model+' '+$year);
  });
  
   
/*============================================================================
  Collection JS for product selection
==============================================================================*/
  $(document).ready(function() {
    var bikeYearTitle = '';
    if( $('.choose-bike-selection').length > 0 ){
      bikeYearTitle = localStorage.getItem('bikeYearTitle');
      setTimeout(function(){
        $('.choose-bike-selection').find('.product-step-config').find('.coll-prod-main-title').find('.sub-title-mobile').text(bikeYearTitle);
      },150);
    }

    // Select the First product of collection
    if( $('.bike-model.step1.active .collection-grid__wrapper #collection-loop .grid-product').length > 0 ){
      $('.bike-model.step1.active .collection-grid__wrapper #collection-loop .grid-product').first().trigger('click');
    }

    // click on Example preview for meta image.
    $('.grid-product .meta_preview_image').click(function(){
      var $thisImage = $(this).closest('.grid-product').data('example-preview');
      console.log('$thisImage',$thisImage);
    });
  });
  //localStorage.setItem("bikeCollUrl",'');

  // Collection page top image
  $(document).on('click', '.bike-model .grid__item .grid .grid-product', function(e){
    e.preventDefault();
    // Clear local storage
    localStorage.setItem("bikeCollUrl",'');    
    var $thisPdp = $(this);
    var $collUrl = $thisPdp.data('coll_url');
    var $collImg = $thisPdp.data('coll_pdpimg');
    var $prodTitle = $thisPdp.data('pdp_title');
    var $prodPrice = $thisPdp.data('pdp_price');
    var $collImgSize  = $thisPdp.data('thumb_size');
    var $thumb_imgArr = $thisPdp.data('thumb_img').split(",");
    var $metaExmaplePrevImg = $thisPdp.data('example-preview');
    $('.collection-grid__wrapper').find('.grid-product').find('.grid-product__link').removeClass('active');
    $thisPdp.find('.grid-product__link').addClass('active');
    // for normal next buttons
    $thisPdp.closest('.bike-model').find('.collection-bike').find('.collection-bike-header').find('.btn.next').attr('href',$collUrl);
    // for mobile next buttons
    $thisPdp.closest('.main-content').find('.choose-bike-selection').find('.choose-bike-option-wrapper').find('.bike-prev-next-button.mobile_step_btn').find('.btn.next').attr('href',$collUrl);
    $thisPdp.closest('.main-content').find('.choose-bike-selection').find('.bike-title').find('h3').text($prodTitle);
    $thisPdp.closest('.main-content').find('.choose-bike-selection').find('.choose-bike-selection-wrapper').find('.bike-image-thumbnail').find('img').attr('src',$collImg);
    $thisPdp.closest('.main-content').find('.choose-bike-selection').find('.choose-bike-option-bottom').find('.choose-bike-price span').text($prodPrice);
    if( $metaExmaplePrevImg != '' ){
      $thisPdp.closest('.main-content').find('.choose-bike-selection').find('.choose-bike-selection-wrapper').find('#inline-popups5').removeClass('hide');
      $thisPdp.closest('.main-content').find('.choose-bike-selection').find('.choose-bike-selection-wrapper').find('#inline-popups5').find('#test-popup-5').find('img').attr('src',$metaExmaplePrevImg);
    } else{
      $thisPdp.closest('.main-content').find('.choose-bike-selection').find('.choose-bike-selection-wrapper').find('#inline-popups5').addClass('hide');
    }
    
    var thumbImgHtml = '';
    if( $collImgSize > 1){
      for (let i=0; i < $collImgSize; i++){
        if( i < 4){
          thumbImgHtml+='<li>';
          thumbImgHtml+='<img src="'+($thumb_imgArr[i]).replace("_920x", "_197x")+'" alt="KTM - &quot;FORCE ATTACK&quot; KIT" data-main-img="'+$thumb_imgArr[i]+'">';
          thumbImgHtml+='</li>';
        }
      }
      $thisPdp.closest('.main-content').find('.choose-bike-selection').find('.choose-bike-selection-wrapper').find('.bike-thumbnail .bike-image').html(thumbImgHtml);
    }  
    var $coll = $collUrl.split('/products/');
    localStorage.setItem("bikeCollUrl",$coll[0]);    
  });
  
  
/* Common Top Next - Prevoius buttons at Banner for Mobile */ /* Common Top Prevoius buttons at TOP for pages coll-pdp */
  // Next
  $(document).on('click','.choose-bike-selection .choose-bike-option-bottom .bike-prev-next-button.mobile_step_btn .btn.next',function(e){
    e.preventDefault();
    var $thisBtn = $(this);
    var hrefLink = $thisBtn.attr('href');
    if( $thisBtn.closest('.main-content').find('.bike-model.active').hasClass('step1') ){
      if(hrefLink != 'javascript:void(0);'){
        location.href = hrefLink;
      }
    }
    if( $thisBtn.closest('.main-content').find('.bike-model.active').hasClass('step2') ){
      $thisBtn.closest('.main-content').find('.bike-model.active').find('.bike-prev-next-button').find('.btn.next').trigger('click');  
    }
    if( $thisBtn.closest('.main-content').find('.bike-model.active').hasClass('step3') ){
      $thisBtn.hide();
    }
  });
  // Prev
  $(document).on('click','.choose-bike-selection .choose-bike-option-bottom .bike-prev-next-button.mobile_step_btn .btn.prev, .product-step-config .coll-prod-main-title a.mobile-prev',function(e){
    e.preventDefault();
    var $thisBtn = $(this);
    var hrefLink = $thisBtn.attr('href');
    if( $thisBtn.closest('.main-content').find('.bike-model.active').hasClass('step1') ){      
      // Mobile reduce progress from step-2 to step-1
      $thisBtn.closest('.choose-bike-option-wrapper').find('.Progress-bar-step.mobile').find('.stepper-wrapper').find('.stepper-item.step-1').removeClass('completed').addClass('active');
      $thisBtn.closest('.choose-bike-option-wrapper').find('.Progress-bar-step.mobile').find('.stepper-wrapper').find('.stepper-item.step-2').removeClass('active');
      if(hrefLink != 'javascript:void(0);'){
        location.href = hrefLink;
      }
    }
    if( $thisBtn.closest('.main-content').find('.bike-model.active').hasClass('step2') ){    
      $thisBtn.closest('.main-content').find('.bike-model.active').find('.bike-prev-next-button').find('.btn.prev').trigger('click');

      // Mobile reduce progress from step-3 to step-2
      //$thisBtn.closest('.choose-bike-option-wrapper').find('.Progress-bar-step.mobile').find('.stepper-wrapper').find('.stepper-item.step-2').removeClass('completed').addClass('active');
      //$thisBtn.closest('.choose-bike-option-wrapper').find('.Progress-bar-step.mobile').find('.stepper-wrapper').find('.stepper-item.step-3').removeClass('completed');
    }
    if( $thisBtn.closest('.main-content').find('.bike-model.active').hasClass('step3') ){
      //$thisBtn.hide();
      $thisBtn.closest('.main-content').find('form').find('.bike-model.step2').addClass('active');
      $thisBtn.closest('.main-content').find('form').find('.bike-model.step3').removeClass('active');
      $thisBtn.closest('.mobile_step_btn').find('.btn.next').show();
      // remove add to cart active from PDP step-2
      $thisBtn.closest('.choose-bike-option-bottom').find('.mobile_step_btn').find('.mobile-add-to-cart').removeClass('active');

      // Mobile reduce progress from step-3 to step-2
      $thisBtn.closest('.choose-bike-option-wrapper').find('.Progress-bar-step.mobile').find('.stepper-wrapper').find('.stepper-item.step-2').removeClass('completed').addClass('active');
      $thisBtn.closest('.choose-bike-option-wrapper').find('.Progress-bar-step.mobile').find('.stepper-wrapper').find('.stepper-item.step-3').removeClass('active');
    }
  });
  // $(document).on('click','.product-step-config .coll-prod-main-title a.mobile-prev',function(e){
  //   e.preventDefault();
  //   var $thisBtn = $(this);
  //   var hrefLink = $thisBtn.attr('href');
  // });

/* Ends */

/* Common Top Banner thumbnail images clicks change main image */
  $(document).on('click','.choose-bike-selection .choose-bike-selection-wrapper .bike-thumbnail ul li img',function(e){
    e.preventDefault();
    var $thisThumb = $(this);
    var $main_img = $thisThumb.data('main-img');
    $thisThumb.closest('.choose-bike-thumb-wrapper').find('.bike-image-thumbnail').find('img').attr('src',$main_img);
    $('.choose-bike-thumb-wrapper').find('.bike-thumbnail').find('.bike-image').find('li').removeClass('active');
    $thisThumb.parent().addClass('active');
  });
/* Ends */


/* Top Steps 1/2/3 Click to go to page JS */
/*
  $(document).on('click','.product-step-config .choose-bike-selection-wrapper .choose-bike-customize-right .stepper-item.step-1.completed a .step-counter',function(e){
    e.preventDefault();
    var $thisStep = $(this);
    var $collUrl='';
    $collUrl = localStorage.getItem('bikeCollUrl');
    console.log('Step 1 counter',$collUrl);
    if($collUrl != null){
      location.href = $collUrl;
    }    
  });
  $(document).on('click','.product-step-config .choose-bike-selection-wrapper .choose-bike-customize-right .stepper-item.step-2.completed a .step-counter',function(e){
    e.preventDefault();
    var $thisStep = $(this);
    var $collUrl='';
    $collUrl = localStorage.getItem('bikeCollUrl');
    console.log('Step 1 counter',$collUrl);
    if($collUrl != null){
      location.href = $collUrl;
    }    
  });
*/
/**/
/* Top Steps 1/2/3 Click to go to page JS */


/*============================================================================
  Product Page JS
==============================================================================*/

$(document).on('click','.bike-model-thumb .thumb-inner .thumb-image',function(e){
  e.preventDefault();
  $('.bike-model-thumb .thumb-inner .thumb-image').removeClass('active');
  var $thisVar = $(this);
  $thisVar.addClass('active');
  var vartitle = $thisVar.data('vartitle');
  varImages(vartitle);  // Varaints wise Main product images/images set
  
  //$('.product-step-config .choose-bike-price').attr('data-price',$thisVar.data('price'));
  var mainProdPrice = parseInt($thisVar.data('price'));  
  totPrice(mainProdPrice);  
});

// Variant wise Main and Thumb images.
function varImages(vartitle){
  var mainImage = $('.bike-image-thumbnail');
  var thumbImage = $('.bike-thumbnail .bike-image');
  var selectedColor = vartitle;
  //console.log('selectedColor',selectedColor);
  mainImage.empty();
  thumbImage.empty();
  var arr = [];
  //console.log("selectedColor =>",selectedColor);
  //console.log("images =>",images);  
  var colorImageArray = jQuery.grep(images, function( n, i ) {           
    return (n.alt == selectedColor || n.alt == prodTitle);
  });
  //console.log('colorImageArray =>',colorImageArray);  
  var addedImage = $.each(colorImageArray,function(i, image){
    var alt = image.alt;
    var url = image.url;  
    var m_id = image.m_id;
    var m_pos = image.m_pos;  
    var m_width = image.m_width;
    var m_height = image.m_height;
    var m_type = image.m_type;
    // if(i == 0){ var isSelected = 'is-selected';}else{var isSelected = '';}
    var countd = i+1;    
    // console.log('i = ',i);
    var mainSlide ='<img class="Image--lazyLoad Image--fadeIn" src="'+url+'" alt="'+alt+'" data-media-position="'+countd+'">';    
    var thumb_url = (url.indexOf('.jpg') > -1) ? url.replace(".jpg", "_197x.jpg") : url.replace(".png", "_197x.png");
    var thumbSlide='<li>';
    thumbSlide+='<img src="'+thumb_url+'" alt="'+alt+'" data-main-img="'+url+'" data-media-position="'+countd+'">';
    thumbSlide+='</li>';    
    // if(m_type == 'video'){
    //   thumbSlide += '<span class="Product__SlideshowNavBadge"><svg class="Icon Icon--media-video-badge" role="presentation" viewBox="0 0 26 26" fill="none">';
    //   thumbSlide += '<path fill-rule="evenodd" clip-rule="evenodd" d="M1 25h24V1H1v24z" fill="#ffffff"></path>';
    //   thumbSlide += '<path d="M.5 25v.5h25V.5H.5V25z" fill="none" stroke="#000000" stroke-opacity=".15"></path>';
    //   thumbSlide += '<path fill-rule="evenodd" clip-rule="evenodd" d="M9.718 6.72a1 1 0 00-1.518.855v10.736a1 1 0 001.562.827l8.35-5.677a1 1 0 00-.044-1.682l-8.35-5.06z" fill="#000000" fill-opacity=".6"></path>';
    //   thumbSlide += '</svg></span>';
    // }      
    mainImage.html(mainSlide);
    thumbImage.append(thumbSlide);
    //console.log("thumbSlide",thumbSlide);    
  });
  arr.push(addedImage);
  $.when.apply($, arr).done(function () {
    // select first from nav
    $('.choose-bike-thumb-wrapper').find('.bike-thumbnail').find('.bike-image').find('li').first().find('img').trigger('click');
  });
}

$(document).ready(function() {
  if( $('.bike-model.step2.active').length > 0 ){    
    var vartitle = $('.bike-model.step2.active').find('.bike-model-left-part').find('.bike-model-thumb').find('.thumb-image.active').data('vartitle');
    varImages(vartitle);  // Varaints wise Main product images/images set
  }
});

// checkbox chekced on pdp page - select any one option.
$(document).on('click','.check-box-item .check-box-wrapper input[type="checkbox"]',function(e){
  //e.preventDefault();
  var $chkThis = $(this);
  var vid = $chkThis.closest('.check-box-item').data('vid');
  var name = $chkThis.closest('.check-box-item').data('name');

  // FLUORECENT COLOR
  //if($chkThis.closest('.florent-color-chrome').length > 0){
    //$('.florent-color-chrome').find('.check-box-wrapper').find('input[type="checkbox"]').prop('checked', false);
    //$('.florent-color-chrome').find('.check-box-item').removeClass('item_added');
    //$chkThis.prop('checked', true);
    //$chkThis.closest('.check-box-item').addClass('item_added');
  //}

  // DECAL FINISH
  if($chkThis.closest('.decal-finish').length > 0){
    $('.decal-finish').find('.check-box-wrapper').find('input[type="checkbox"]').prop('checked', false);
    $('.decal-finish').find('.check-box-item').removeClass('item_added');
    $chkThis.prop('checked', true);
    $chkThis.closest('.check-box-item').addClass('item_added');
  } else {
    if(($chkThis).is(':checked')){
      $chkThis.closest('.check-box-item').addClass('item_added');
    }else{    
      $chkThis.closest('.check-box-item').removeClass('item_added');
    }  
  }

  // EXTRA OPTIONS 
  //if($chkThis.closest('.extra-option').length > 0){
    //$('.extra-option').find('.check-box-wrapper').find('input[type="checkbox"]').prop('checked', false);
    //$('.extra-option').find('.check-box-item').removeClass('item_added');
    //$chkThis.prop('checked', true);
    //$chkThis.closest('.check-box-item').addClass('item_added');
  //}
  
  var mainProdPrice = $('.bike-model-thumb .thumb-image.active').data('price');
  totPrice(mainProdPrice);
  
});

// To calculate the price based on variant and option selected.
function totPrice(mainProdPrice){
  // var prodQty = 1;  // parseInt($('.quantity__input[name="quantity"]').val());  
  var TotalPrice = 0; var TotalCmpPrice = 0;
  var mainProdPrice = parseInt(mainProdPrice); //$('.product-step-config .choose-bike-price').data('price');
  // console.log( 'TotalPrice=>', TotalPrice );
  $('.item_added').each(function(){
    // console.log( '=>', $(this).attr('dataprice') );
    TotalPrice = TotalPrice + parseInt($(this).attr('data-price'));
    // TotalCmpPrice = TotalCmpPrice + parseInt($(this).attr('datacompareprice'));
  });
  TotalPrice = TotalPrice + mainProdPrice;
  // TotalCmpPrice = TotalCmpPrice + mainProdCmpPrice;
  // TotalPrice = TotalPrice * prodQty;
  // TotalCmpPrice = TotalCmpPrice * prodQty;  
  console.log( 'TotalPrice=>', TotalPrice );
  $('.product-step-config .choose-bike-price').find('span').html(Shopify.formatMoney(TotalPrice, theme.moneyFormat));
}


$('.item_added').each(function(){
  console.log('item_added =>', $(this).attr('data-vid'));
  //theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat)
});


// PDP Page Step-2 buttons
$(document).on('click','.bike-model .bike-model-right-part .bike-prev-next-button .btn.next',function(e){
  //e.preventDefault();
  var $thisBike = $(this);
  console.log('Bike Nxt',$thisBike);

  // if important notes checkbox is checked ?
  if( $('main').find('form').find('.bike-model.step2.active').find('.bike-model-right-part .read-important-note').find('input[name="imp_notes"]').is(":checked") ){
    
    $thisBike.closest('form').find('.bike-model.step2').removeClass('active');
    $thisBike.closest('form').find('.bike-model.step3').addClass('active');
    $thisBike.closest('main').find('.product-step-config').find('.choose-bike-option-wrapper').find('.bike-prev-next-button').find('.mobile-add-to-cart').addClass('active');
    // Make progress bar 3 active
    $thisBike.closest('main').find('.product-step-config').find('.choose-bike-selection-wrapper').find('.choose-bike-customize-right').find('.stepper-wrapper').find('.stepper-item.step-2').removeClass('active').addClass('completed');
    $thisBike.closest('main').find('.product-step-config').find('.choose-bike-selection-wrapper').find('.choose-bike-customize-right').find('.stepper-wrapper').find('.stepper-item.step-3').addClass('active');
  
    // Mobile Make progress bar 3 active
    $thisBike.closest('main').find('.product-step-config').find('.choose-bike-option-wrapper').find('.Progress-bar-step.mobile').find('.stepper-wrapper').find('.stepper-item.step-2').removeClass('active').addClass('completed');  
    $thisBike.closest('main').find('.product-step-config').find('.choose-bike-option-wrapper').find('.Progress-bar-step.mobile').find('.stepper-wrapper').find('.stepper-item.step-3').addClass('active');
  
    // Mobile hide next btn
    $thisBike.closest('main').find('.product-step-config').find('.choose-bike-option-wrapper').find('.bike-prev-next-button.mobile_step_btn').find('.btn.next').hide();

  } else{
    // alert('Please check important notes!');
    $.magnificPopup.open({
      items: {
        src: '#imp-note-popup'
      },
        type: 'inline'
    }, 0);
  }
  
});

$(document).on('click','.bike-model .bike-model-right-part .bike-prev-next-button .btn.prev',function(e){
  e.preventDefault();
  var $thisBike = $(this);
  console.log('Bike Prev',$thisBike);  
  // Make progress bar 3 active
  //$thisBike.closest('main').find('.product-step-config').find('.choose-bike-selection-wrapper').find('.choose-bike-customize-right').find('.stepper-wrapper').find('.stepper-item.step-2').removeClass('completed').addClass('active');
  //$thisBike.closest('main').find('.product-step-config').find('.choose-bike-selection-wrapper').find('.choose-bike-customize-right').find('.stepper-wrapper').find('.stepper-item.step-3').removeClass('active');
  var $collUrl='';  
  $collUrl = localStorage.getItem('bikeCollUrl');
  console.log('f',$collUrl);
  if($collUrl != null){
    location.href = $collUrl;
  }
});



// PDP Page Step-3 buttons
$(document).on('click','.bike-model .bike-model-right-part .bike-add-to-cart .previw-link',function(e){
  e.preventDefault();
  var $thisBikePrev = $(this);
  console.log('AddCart Prev',$thisBikePrev);
  $thisBikePrev.closest('form').find('.bike-model.step2').addClass('active');
  $thisBikePrev.closest('form').find('.bike-model.step3').removeClass('active');
  $thisBikePrev.closest('main').find('.product-step-config').find('.choose-bike-option-wrapper').find('.bike-prev-next-button').find('.btn.next').show();
  $thisBikePrev.closest('main').find('.product-step-config').find('.choose-bike-option-wrapper').find('.bike-prev-next-button').find('.mobile-add-to-cart').removeClass('active');

  // Mobile remove progress from step-3 to step-2
  $thisBikePrev.closest('main').find('.product-step-config').find('.choose-bike-option-wrapper').find('.Progress-bar-step.mobile').find('.stepper-wrapper').find('.stepper-item.step-2').removeClass('completed').addClass('active');
  $thisBikePrev.closest('main').find('.product-step-config').find('.choose-bike-option-wrapper').find('.Progress-bar-step.mobile').find('.stepper-wrapper').find('.stepper-item.step-3').removeClass('completed');

  // Make progress bar 3 active
  $thisBikePrev.closest('main').find('.product-step-config').find('.choose-bike-selection-wrapper').find('.choose-bike-customize-right').find('.stepper-wrapper').find('.stepper-item.step-2').removeClass('completed').addClass('active');
  $thisBikePrev.closest('main').find('.product-step-config').find('.choose-bike-selection-wrapper').find('.choose-bike-customize-right').find('.stepper-wrapper').find('.stepper-item.step-3').removeClass('active');
});


// Mobile Top add to cart button -- trigger bottom button.
$(document).on('click','.choose-bike-option-wrapper .mobile-add-to-cart.active',function(e){
  e.preventDefault();
  $(this).closest('main').find('form').find('.bike-model.step3').find('.bike-add-to-cart').find('.step-addToCart').trigger('click');
});

$(document).ready(function() {
// Left out prod qty on step 3 PDP page
// function rand_spots(){
//   var randNumber = Math.round(Math.random()*10);
//   if( $('.bike-model.step3').length > 0 ){
//     $('body').find('main').find('form').find('.bike-model.step3').find('.bike-model-right-part .kit-complete').find('.spot-left').find('.left_qty').text(randNumber);
//   }  
// }
// rand_spots();

  function rand_spots_count(){
    var now = new Date();
    var timeNow = now.getHours();
    console.log('timeNow',timeNow);
    //var count = (timeNow / 2.5);
    var count = (timeNow * 2.5);
    var newCount = Math.ceil(50 - count);
    console.log('newCount',newCount);
    if(newCount < 1){
      newCount = 1;
    }
    if(newCount >= 25){
      newCount = 25;
    }
    $('body').find('main').find('form').find('.bike-model.step3').find('.bike-model-right-part .kit-complete').find('.spot-left').find('.left_qty').text(newCount);
  }
  rand_spots_count();
});



// Step Add to cart btn
$(document).on('click','.bike-add-to-cart .step-addToCart',function(e){  
  
  e.preventDefault();
  var $thisPdp = $(this);
  var timestamp = Date.now();
  let arr = [];
  let properties = {};
  let prop = {};
  var dataArray = $('.AddToCartForm').serializeArray();
  var dataObj = {};
  var mainProps = {};
  var mainProdObj = {};

  console.log('dataArray => ',dataArray);

  //dataObj.push({'name':'id', 'value': parseInt($('.thumb-inner .thumb-image.active').data('vid'))});
  //dataArray.push({'name':'quantity', 'value': 1});
  
  // Main prod push
  var mainProd = $('.thumb-inner .thumb-image.active').data('vid');
  //prop = {'_timestamp':+timestamp,'_main_prod':'Yes'};
  //arr.push({'id':mainProd, 'quantity': 1,'properties':prop});

  // Add-on Products push
  $('.item_added').each(function(){
    if($(this).attr('data-vid')){
      var itemId = $(this).data('vid');
      prop = {'_timestamp':+timestamp};
      arr.push({'id': itemId, 'quantity': 1,'properties':prop});
    }
  });
  
  $(dataArray).each(function(i, field){
    if(field.value != ''){
      dataObj[field.name] = field.value;
      // console.log('PP=>',dataObj[field.name].indexOf('properties') );
      if(dataObj[field.name].indexOf('properties') > -1){
        properties[field.name] = field.value
      }
    }
  });
  //console.log('dataObj ',dataObj);
  
  properties["properties[_timestamp]"] = timestamp;
  properties["properties[_main_prod]"] = 'Yes';
  //console.log('properties ',properties);

  mainProps = $.extend(dataObj, properties);  
  //console.log('mainProps =',mainProps);

  mainProdObj = $.extend({'id':mainProd, 'quantity': 1}, mainProps);
  //console.log('mainProdObj =',mainProdObj);
  
  arr.push(mainProdObj);
  
  // properties push
  //if(dataObj.properties){
    //arr.push(properties);
  //}
  //console.log('arr =>',arr);

  let formData = {'items': arr};
  
  //console.log('FormData => ',formData);
  
  //return false;
  
  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    data: formData,
    dataType: 'json',
    success: function(cart){
      window.location.href = "/cart";
      // var cart = new theme.CartDrawer;
      // cart.init();
      // cart.open();
    },
    error: function(status){      
      console.log('Error Status',status.error);
    }
  });
  return false;
});



// Update Qty using button +/- for bundle.
function updateQty(){
  $(document).on('click','.cart__item-list .main-prod .js-qty__wrapper .QuantitySelector__Button',function(e){
    e.preventDefault();
    e.stopPropagation();
    var toUpdate = { updates: {} };
    var mainpdptimestamp = $(this).closest('.cart__item').data('timestamp');
    
    var mainpdpqty = $(this).closest('.js-qty__wrapper').find('input').val();
    toUpdate.updates[$(this).closest('.cart__item').data('itemid')] = mainpdpqty;
    if(mainpdptimestamp != ""){
      $('.cart__item-list .cart__item:not(.main-prod)').each(function(){
        if($(this).data('timestamp') ==  mainpdptimestamp){
          //$(this).find('input.cart-item__qty-input').val(mainpdpqty);
          toUpdate.updates[$(this).data('itemid')] = mainpdpqty;
        }
      });
    }
    console.log('updateQty',toUpdate);
    setTimeout(function() {
      var paramsup = {
        type: 'POST',
        url: '/cart/update.js',
        data: toUpdate,
        dataType: 'json',
        success: function() {
          if( $('.template-cart').length > 0 ){
            location.reload();
          } else {
            var cart = new theme.CartDrawer;
            cart.init();
          }
          console.log('Success');
        },
        error: function(err) {
          console.error('Error',err);
        }
      };
      $.ajax(paramsup);
      return false;
    }, 450);
  });
} updateQty();

// Update Qty in cart and Drawer for bundle product
function updateDrawerQty(){
  $(document).on('change','.cart__item-list .main-prod .js-qty__wrapper input[name="updates[]"]',function(e){
    e.preventDefault();
    var toUpdate = { updates: {} };
    var mainpdptimestamp = $(this).closest('.cart__item').data('timestamp');
    var mainpdpqty = $(this).val();
    console.log('mainpdpqty',mainpdpqty);
    toUpdate.updates[$(this).closest('.cart__item').data('itemid')] = mainpdpqty;
    if(mainpdptimestamp != ""){
      $('.cart__item-list .cart__item:not(.main-prod)').each(function(){
        if($(this).data('timestamp') ==  mainpdptimestamp){
          //$(this).find('input.cart-item__qty-input').val(mainpdpqty);
          toUpdate.updates[$(this).data('itemid')] = mainpdpqty;
        }
      });
    }
    console.log('updateDrawerQty',toUpdate);
    setTimeout(function() {
      var paramsup = {
        type: 'POST',
        url: '/cart/update.js',
        data: toUpdate,
        dataType: 'json',
        success: function() {
          if( $('.template-cart').length > 0 ){
            location.reload();
          } else {
            var cart = new theme.CartDrawer;          
            cart.init();
          }
          console.log('Success');
        },
        error: function(err) {
          console.error('Error',err);
        }
      };
      $.ajax(paramsup);
      return false;
    }, 450);
  });
} updateDrawerQty();

// Remove Products from cart and drawer
function removeProducts(){
  $(document).on('click','.cart__item .cart__remove-config',function(e){
    e.preventDefault();
    // console.log('Remove Clicked');    
    var dataRemove = { updates: {} };
    if( $(this).closest('.cart__item').hasClass('main-prod') ){
      var mainpdptimestamp = $(this).closest('.cart__item').data('timestamp');
      dataRemove.updates[$(this).closest('.cart__item').data('itemid')] = 0;
      if(mainpdptimestamp != ""){
        $('.cart__item-list .cart__item:not(.main-prod)').each(function(){
          if($(this).data('timestamp') ==  mainpdptimestamp){
            //toRemove += 'updates['+$(this).data('itemid')+']=0&';            
            dataRemove.updates[$(this).data('itemid')] = 0;
          }
        });
      }
    }
    console.log('dataRemove',dataRemove);
    var paramsup = {
      type: 'POST',
      url: '/cart/update.js',
      data: dataRemove, //toRemove.substring(0, toRemove.length - 1),
      dataType: 'json',
      success: function() {
        if( $('.template-cart').length > 0 ){
          location.reload();
        } else {
          var cart = new theme.CartDrawer;          
          cart.init();
        }
        console.log('Success');
      },
      error: function(err) {
        console.error('Error',err);
      }
    };
    $.ajax(paramsup);
    return false;
  });
} removeProducts();


// Total in cart page.
$(document).ready(function() {
  //let mainPro = [];
  $('.cart__item-list .main-prod').each(function(){
    var $this = $(this);
    var $mainPrice = $this.data('price');
    var mainQty = parseInt($this.find('.cart__item-sub .js-qty__num').val());
    var totalPrice = 0;
    //mainPro.push($this.data('timestamp'));
    var $mainTime = $this.data('timestamp')
    $('.sub-prod[data-timestamp="'+$mainTime+'"]').each(function(){
      var $thisub = $(this);
      console.log('test',$thisub.data('price'));
      var $subPrice = $thisub.data('price');
      totalPrice = totalPrice + $subPrice;
    });
    totalPrice = totalPrice + $mainPrice;
    totalPrice = (totalPrice * mainQty);
    $('.main-prod[data-timestamp="'+$mainTime+'"]').find('.cart__item-details').find('.cart__item-sub').find('.cart__price').text(Shopify.formatMoney(totalPrice, theme.moneyFormat));
    $('.main-prod[data-timestamp="'+$mainTime+'"]').find('.cart-mobile-tab').find('.cart__item-sub').find('.cart__price').text(Shopify.formatMoney(totalPrice, theme.moneyFormat));
  });
});







